module.exports = __webpack_public_path__ + "media/images/athletes/4343-c5e2357bad3cd8927cf00a6156a89629.png";